import React, { useState } from "react";
import CenterModal from "../Components/CenterModal";
import API from '../Services/Coupon'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CouponList from "./CouponList";

const Coupon = () => {
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [code, setCode] = useState("")
    const [type, setType] = useState("")
    const [description, setaDescription] = useState("")
    const [discount, setDiscount] = useState("")
    const [purchaseAmount, setPurchaseAmount] = useState("")
    const [limit, setLimit] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [center, setCenter] = useState("")
    const [error, setError] = useState({});



    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        switch (fieldName) {
            case "code":
                setCode(value);
                break;
            case "type":
                setType(value);
                break;
            case "center":
                setSelectedCenter(value);
                break;
            case "discount":
                setDiscount(value);
                break;
            case "purchaseAmount":
                setPurchaseAmount(value);
                break;
            case "limit":
                setLimit(value);
                break;
            case "startDate":
                setStartDate(value);
                break;
            case "endDate":
                setEndDate(value);
                break;
            case "description":
                setaDescription(value);
                break;
        }

    }


    const validateFields = () => {
        const errors = {};
        if (!code.trim()) errors.code = "Coupon code is required";
        if (!type) errors.type = "Type is required";
        if (!description.trim()) errors.description = "Description is required";
        if (!discount || isNaN(Number(discount))) errors.discount = "Valid discount is required";
        if (!purchaseAmount || isNaN(Number(purchaseAmount)))
            errors.purchaseAmount = "Valid purchase amount is required";
        if (!limit || isNaN(Number(limit))) errors.limit = "Valid usage limit is required";
        if (!startDate) errors.startDate = "Start date is required";
        if (!endDate) errors.endDate = "End date is required";
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            errors.endDate = "End date cannot be earlier than start date";
        }
        if (selectedCenter.length === 0) errors.center = "Please select at least one center";
        setError(errors);
        return Object.keys(errors).length === 0;
    };



    const addCouponData = async () => {
        if (!validateFields()) return;
        const paylaod = {
            code: code,
            location_id: selectedCenter.join(","),
            description: description,
            type: type,
            discount: parseInt(discount),
            min_purchase_amount: parseInt(purchaseAmount),
            usage_limit: parseInt(limit),
            start_date: startDate,
            end_date: endDate,
            is_active: 1,
        }
        try {
            const response = await API.addCoupons(paylaod)
            //console.log("response data........", response?.data?.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Coupons successful!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Coupons failed.");
            }
        } catch (error) {
            if (error.response) {
                // console.error("Response data:", error.response.data);
                const errorMessage =
                    error.response.data?.message || `Error: ${error.response.status}`;
                toast.error(errorMessage);
            }
            else if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please try again later.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    }


    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addCouponData();

    };

    const handleCancel = () => {
        window.location.reload();
        setSelectedCenter([''])
        setCode('')
        setType('')
        setaDescription('')
        setDiscount('')
        setPurchaseAmount('')
        setLimit('')
        setStartDate('')
        setEndDate('')
    }



    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Coupon</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Code <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Code"
                                            value={code}
                                            onChange={(e) => handleFieldChange(e, "code")}
                                        />
                                        {error?.code && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.code}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <CenterModal onSelectCenter={handleSelectedCenter} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Type <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={type}
                                            onChange={(e) => handleFieldChange(e, "type")}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="percentage">Percentage</option>
                                            <option value="amount">Amount</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Description <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Description"
                                            value={description}
                                            onChange={(e) => handleFieldChange(e, "description")}
                                        />
                                        {error?.description && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.description}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Discount <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="discount"
                                            value={discount}
                                            onChange={(e) => handleFieldChange(e, "discount")}
                                        />
                                        {error?.discount && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.discount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Purchase Amount <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Purchase Amount"
                                            value={purchaseAmount}
                                            onChange={(e) => handleFieldChange(e, "purchaseAmount")}
                                        />
                                        {error?.purchaseAmount && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.purchaseAmount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Limit <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Limit"
                                            value={limit}
                                            onChange={(e) => handleFieldChange(e, "limit")}
                                        />
                                        {error?.limit && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.limit}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Start Date <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            placeholder="start Date"
                                            value={startDate}
                                            onChange={(e) => handleFieldChange(e, "startDate")}
                                        />
                                        {error?.startDate && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.startDate}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Expiry Date <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            placeholder="End Date"
                                            value={endDate}
                                            onChange={(e) => handleFieldChange(e, "endDate")}
                                        />
                                        {error?.endDate && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.endDate}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                <button
                                    onClick={handleSubmit}
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Submit
                                </button>
                                <button  onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <CouponList />
        </div>
    )
}

export default Coupon
